(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dt-english-image-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  // Only approved English panel markup contains these hooks. Original images stay untouched.
  const selector = 'svg[data-dt-english-panel]';
  const pending = new WeakMap();
  const seen = new WeakSet();
  const ready = (panel) => panel.dataset.dtPanelState === 'ready' || panel.dataset.dtPanelState === 'fallback';
  const visible = (panel) => panel.getBoundingClientRect().width > 0 && panel.getBoundingClientRect().height > 0;
  const sourceFor = (panel) => {
    const box = panel.getBoundingClientRect();
    const view = panel.viewBox.baseVal;
    const scale = (panel.getAttribute('preserveAspectRatio').includes('meet') ? Math.min : Math.max)(box.width / view.width, box.height / view.height);
    const width = Math.ceil(view.width * scale * Math.min(window.devicePixelRatio || 1, 2));
    const image = panel.querySelector('image[data-dt-panel-src]');
    if (width <= 480) return image.dataset.dtPanelWidth480;
    if (width <= 960) return image.dataset.dtPanelWidth960;
    if (width <= 1600) return image.dataset.dtPanelWidth1600;
    return image.dataset.dtPanelSrc;
  };
  const load = (panel) => {
    if (!visible(panel) || ready(panel)) return Promise.resolve();
    if (pending.has(panel)) return pending.get(panel);
    const image = panel.querySelector('image[data-dt-panel-src]');
    const layer = panel.querySelector('[data-dt-panel-layer]');
    const selected = sourceFor(panel);
    panel.dataset.dtPanelState = 'loading';
    const promise = new Promise((resolve) => {
      // Decode in an HTML image before exposing the SVG layer, including its underlays.
      const probe = new Image();
      let timer;
      let finished = false;
      const finish = (ok) => {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        if (ok) {
          image.setAttribute('href', probe.src);
          requestAnimationFrame(() => requestAnimationFrame(() => {
            layer.style.visibility = 'visible';
            panel.dataset.dtPanelState = 'ready';
            resolve();
          }));
        } else {
          panel.dataset.dtPanelState = 'fallback';
          resolve();
        }
      };
      probe.onload = () => {
        // onload guarantees the resource; decode avoids transitioning before decoding finishes.
        if (probe.decode) probe.decode().catch(() => {}).then(() => finish(true));
        else finish(true);
      };
      probe.onerror = () => {
        // One original-size fallback if a resized CDN variant is unavailable.
        if (probe.src !== new URL(image.dataset.dtPanelSrc, document.baseURI).href) {
          probe.src = image.dataset.dtPanelSrc;
        } else finish(false);
      };
      timer = setTimeout(() => finish(false), 10000);
      probe.src = selected;
    });
    pending.set(panel, promise);
    return promise;
  };
  const panelsIn = (node) => Array.from(node.querySelectorAll(selector)).filter(visible);
  const prepare = (node) => Promise.all(panelsIn(node).map(load));
  const prepared = (node) => panelsIn(node).every(ready);
  const wireSlideshow = (component) => {
    if (component.dataset.dtPanelGuard || !component.querySelector(selector) || !component.slider || typeof component.setSlidePosition !== 'function') return;
    component.dataset.dtPanelGuard = 'true';
    const slides = Array.from(component.slider.querySelectorAll('.slideshow__slide'));
    const originalMove = component.setSlidePosition.bind(component);
    let sequence = 0;
    const indexAt = (position) => Math.max(0, Math.min(slides.length - 1, Math.round(position / (component.sliderItemOffset || slides[0].clientWidth))));
    const current = () => indexAt(component.slider.scrollLeft);
    const adjacent = (delta) => slides[(current() + delta + slides.length) % slides.length];
    component.setSlidePosition = (position) => {
      const token = ++sequence;
      const target = slides[indexAt(position)];
      if (!target || prepared(target)) return originalMove(position);
      prepare(target).then(() => { if (token === sequence && component.isConnected) originalMove(position); });
    };
    // Dawn's counter links bypass setSlidePosition; route only these links through the same guard.
    component.addEventListener('click', (event) => {
      const link = event.target.closest('.slider-counter__link');
      const index = component.sliderControlLinksArray?.indexOf(link) ?? -1;
      if (index < 0) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      component.setSlidePosition(component.slider.scrollLeft + component.sliderFirstItemNode.clientWidth * (index + 1 - component.currentPage));
    }, true);
    const cancelPendingMove = () => {
      sequence += 1;
      clearTimeout(component.setPositionTimeout);
    };
    let touchX = null;
    let touchY = null;
    component.slider.addEventListener('touchstart', (event) => {
      cancelPendingMove();
      touchX = event.touches[0]?.clientX ?? null;
      touchY = event.touches[0]?.clientY ?? null;
      prepare(adjacent(1));
      prepare(adjacent(-1));
    }, { passive: true });
    // Native swipe/wheel can bypass component methods. Hold only a pending direction, never blank the photo.
    component.slider.addEventListener('touchmove', (event) => {
      if (touchX === null || !event.touches[0]) return;
      const delta = touchX - event.touches[0].clientX;
      const vertical = touchY - event.touches[0].clientY;
      if (Math.abs(delta) > Math.max(8, Math.abs(vertical)) && !prepared(adjacent(delta > 0 ? 1 : -1))) {
        if (event.cancelable) event.preventDefault();
        prepare(adjacent(delta > 0 ? 1 : -1));
      }
    }, { passive: false });
    component.slider.addEventListener('touchend', () => { touchX = null; touchY = null; }, { passive: true });
    component.slider.addEventListener('touchcancel', () => { touchX = null; touchY = null; }, { passive: true });
    component.slider.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      cancelPendingMove();
      const target = adjacent(event.deltaX > 0 ? 1 : -1);
      if (!prepared(target)) {
        if (event.cancelable) event.preventDefault();
        prepare(target);
      }
    }, { passive: false });
    component.addEventListener('slideChanged', () => { sequence += 1; prepare(slides[current()]); prepare(adjacent(1)); });
    prepare(slides[current()]);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && visible(entry.target)) {
        load(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '300px 0px' }) : null;
  const init = (scope = document) => {
    scope.querySelectorAll(selector).forEach((panel) => {
      if (seen.has(panel)) return;
      seen.add(panel);
      const slide = panel.closest('.slideshow__slide');
      if (slide) return; // Slideshow transitions, not page intersection, own hidden-slide loading.
      if (panel.dataset.dtPanelEager === 'true' || !observer) load(panel);
      else observer.observe(panel);
    });
    customElements.whenDefined('slideshow-component').then(() => scope.querySelectorAll('slideshow-component').forEach(wireSlideshow));
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('slideshow-component[data-dt-panel-guard]').forEach((component) => {
        const slides = component.slider.querySelectorAll('.slideshow__slide');
        if (slides[component.currentPage - 1]) prepare(slides[component.currentPage - 1]);
      });
    }, 150);
  }, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dt-shopping-preferences"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dt-shopping-preferences')) {
    customElements.define('dt-shopping-preferences', class extends HTMLElement {
      connectedCallback() {
        const details = this.querySelector('details');
        if (!details) return;
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const close = (focus) => {
          details.open = false;
          if (focus) details.querySelector('summary').focus();
        };
        this.querySelector('.dt-preferences__close').addEventListener('click', () => close(true), options);
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape' && details.open) { event.stopPropagation(); close(true); }
        }, options);
        document.addEventListener('click', (event) => { if (details.open && !this.contains(event.target)) close(false); }, options);
        this.addEventListener('focusout', (event) => { if (event.relatedTarget && !this.contains(event.relatedTarget)) close(false); }, options);
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
